'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _chemist = require('chemist');

var _reactI18next = require('react-i18next');

var _style = require('./style.scss');

var _style2 = _interopRequireDefault(_style);

var _translate = require('../../helpers/translate');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FooterPromotions = (_dec = (0, _chemist.configurable)(), _dec2 = (0, _reactI18next.translate)(), _dec3 = (0, _reactCssModules2.default)(_style2.default), _dec(_class = _dec2(_class = _dec3(_class = function (_React$Component) {
  (0, _inherits3.default)(FooterPromotions, _React$Component);

  function FooterPromotions() {
    (0, _classCallCheck3.default)(this, FooterPromotions);
    return (0, _possibleConstructorReturn3.default)(this, (FooterPromotions.__proto__ || (0, _getPrototypeOf2.default)(FooterPromotions)).apply(this, arguments));
  }

  (0, _createClass3.default)(FooterPromotions, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          code = _props.config.store.code;


      var href1 = (0, _translate.contextualTranslation)(t, code, 'flourish.footer_promotions.href_1');
      var title1 = (0, _translate.contextualTranslation)(t, code, 'flourish.footer_promotions.title_1');
      var text1 = (0, _translate.contextualTranslation)(t, code, 'flourish.footer_promotions.text_1');
      var title2 = (0, _translate.contextualTranslation)(t, code, 'flourish.footer_promotions.title_2');
      var text2 = (0, _translate.contextualTranslation)(t, code, 'flourish.footer_promotions.text_2');

      return _react2.default.createElement(
        'section',
        { styleName: 'footerPromotions' },
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'col-sm-6', styleName: 'footerPromotion' },
              _react2.default.createElement(
                'div',
                { className: 'row' },
                _react2.default.createElement(
                  'article',
                  { styleName: 'promotion', className: 'col-sm-8' },
                  href1 !== '' ? _react2.default.createElement(
                    'h3',
                    { className: 't-title t-title--secondary' },
                    _react2.default.createElement(
                      'a',
                      {
                        styleName: 'a-promotion-href',
                        href: href1
                      },
                      title1
                    )
                  ) : _react2.default.createElement(
                    'h3',
                    { className: 't-title t-title--secondary' },
                    title1
                  ),
                  _react2.default.createElement(
                    'p',
                    { className: 't-text' },
                    text1
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-sm-6', styleName: 'footerPromotion' },
              _react2.default.createElement(
                'div',
                { className: 'row' },
                _react2.default.createElement(
                  'article',
                  { styleName: 'promotion', className: 'col-sm-8' },
                  _react2.default.createElement(
                    'h3',
                    { className: 't-title t-title--secondary' },
                    title2
                  ),
                  _react2.default.createElement(
                    'p',
                    { className: 't-text' },
                    text2
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return FooterPromotions;
}(_react2.default.Component)) || _class) || _class) || _class);
exports.default = FooterPromotions;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/FooterPromotions/index.js
// module id = 2285
// module chunks = 0